import apiClient from './client';

export interface Event {
  _id: string;
  title: string;
  description: string;
  image?: string;
  startDate: string;
  endDate?: string;
  location?: string;
  status: string;
  isPublished: boolean;
  registrationLink?: string;
  additionalInfo?: Record<string, any>;
}

export interface CreateEventDto {
  title: string;
  description: string;
  image?: string;
  startDate: Date;
  endDate?: Date;
  location?: string;
  registrationLink?: string;
}

export const eventsApi = {
  getAll: async (): Promise<Event[]> => {
    const response = await apiClient.get('/events');
    return response.data;
  },

  getUpcoming: async (): Promise<Event[]> => {
    const response = await apiClient.get('/events/upcoming');
    return response.data;
  },

  getById: async (id: string): Promise<Event> => {
    const response = await apiClient.get(`/events/${id}`);
    return response.data;
  },

  create: async (data: CreateEventDto): Promise<Event> => {
    const response = await apiClient.post('/events', data);
    return response.data;
  },

  update: async (id: string, data: Partial<CreateEventDto>): Promise<Event> => {
    const response = await apiClient.put(`/events/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/events/${id}`);
  },
};
